// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1zE3T","right":"styles_right__3uSeP"};